import { makeStyles } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import "./style.scss"

const useStyles = makeStyles({
  Header: {
    display: "grid",
    gridTemplateColumns: 'repeat( auto-fill, minmax(140px,1fr) )',
    gridGap: "15px",
    alignItems: "center",
    paddingLeft: "35px",
    position: "sticky",
    top: "0",
    backgroundColor: "#38A169",
    padding: "5px 0 5px 0"
  },

  Link: {
    textAlign: "center",
    textDecoration: "none",
    backgroundColor: "#0BC5EA",
    borderRadius: "4px",
    width: "140px",
    padding: "5px",
    boxShadow: "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    color: "white",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#00A3C4",
      boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)"
    },
    "& active": {
      backgroundColor: "#00A3C4"
    }
  },

});

export const Sidebar = () => {
  const classes = useStyles();

  return (
    <div className={classes.Header}>
      <NavLink to="/booklist" className={classes.Link}>新刊情報</NavLink>
      <NavLink to="/recommend" className={classes.Link}>オススメマンガ</NavLink>
      <NavLink to="/boys" className={classes.Link}>少年マンガ</NavLink>
      <NavLink to="/girls" className={classes.Link}>少女マンガ</NavLink>
      <NavLink to="/ladys" className={classes.Link}>女性マンガ</NavLink>
      <NavLink to="/4coma" className={classes.Link}>4コマまんが</NavLink>
      <NavLink to="/dmmbook" className={classes.Link}>マンガ</NavLink>
      <NavLink to="/magazine" className={classes.Link}>マンガ雑誌</NavLink>
      <NavLink to="/adultphoto" className={classes.Link} style={{ backgroundColor: "#322659" }}>写真集1</NavLink>
      <NavLink to="/photo" className={classes.Link} style={{ backgroundColor: "#322659" }}>写真集2</NavLink>
      <NavLink to="/adult" className={classes.Link} style={{ backgroundColor: "#322659" }}>成年雑誌</NavLink>
      <NavLink to="/movie" className={classes.Link} style={{ backgroundColor: "#322659" }}>動画</NavLink>
      <NavLink to="/search" className={classes.Link} style={{ backgroundColor: "#322659" }}>検索</NavLink>
      <NavLink to="/anime" className={classes.Link}>Anime</NavLink>
      {/* <NavLink to="/parent" className={classes.Link}>Parent</NavLink> */}
    </div>
  );
};
